import React from "react";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function LoyaltyMembers() {
  return (
    <ResourcePage
      endpoint="/loyalty-members"
      testidPrefix="loyalty"
      eyebrow="Stakeholders"
      title="Loyalty Members"
      subtitle="Customer loyalty programme membership and points."
      ctaLabel="Enrol member"
      fields={[
        { name: "member_number", label: "Member #", required: true },
        { name: "full_name", label: "Full name", required: true },
        { name: "phone", label: "Phone" },
        { name: "email", label: "Email" },
        { name: "home_branch", label: "Home branch" },
        { name: "tier", label: "Tier", type: "select", default: "bronze",
          options: ["bronze", "silver", "gold", "platinum"] },
        { name: "points", label: "Points", type: "number" },
      ]}
      columns={[
        { key: "member_number", label: "Member #" },
        { key: "full_name", label: "Name" },
        { key: "phone", label: "Phone" },
        { key: "home_branch", label: "Home branch" },
        { key: "tier", label: "Tier", render: (i) => <Badge tone={i.tier === "platinum" ? "blue" : i.tier === "gold" ? "amber" : i.tier === "silver" ? "gray" : "slate"}>{i.tier}</Badge> },
        { key: "points", label: "Points" },
      ]}
      searchKeys={["member_number", "full_name", "phone", "email"]}
    />
  );
}
